import Modal from 'bootstrap.native/src/components-v4/modal-native'

export default class AdGeneratorExtension {

	constructor(naja) {
		this.naja = naja;
		naja.addEventListener('init', this._init.bind(this));
	}

	/**
	 * @private
	 */
	_init() {
		const adminBox = document.getElementById('fn_admin-control-box');

		if (!adminBox) {
			return;
		}

		const buttonWrapper = document.createElement('li');
		const button = document.createElement('a');
		button.innerText = 'Generate newsletter';
		button.href = '#';
		buttonWrapper.appendChild(button);
		Array.from(adminBox.querySelectorAll('ul')).pop().appendChild(buttonWrapper);

		button.addEventListener('click', (e) => {
			e.preventDefault();

			const inputs = document.querySelectorAll('input[name=ad-generator]');

			let productsIds = [];
			inputs.forEach((input) => {
				if (input.checked) {
					productsIds.push(parseInt(input.value));
				}
			});

			if (productsIds.length === 0) {
				alert('Nejsou vybrané žádné produkty.');
				return;
			}

			this.naja.makeRequest('POST', '/api/v1/admin/adgen/from-ids', {ids: productsIds}, {history: false})
				.then((response) => {
					this._showModal(response.result);
					navigator.clipboard.writeText(response.result);
				});
		});
	}

	_showModal(html) {
		if (!this.modal) {
			this.modalEl = document.createElement('div');
			this.modalEl.classList.add('modal');
			this.modalEl.id = 'fn_adGenerator-modal';
			this.modalEl.innerHTML = '<div class="modal-dialog modal-xl">' +
				'    <div class="modal-content">' +
				'      <div class="modal-header">' +
				'        <h4 class="modal-title">HTML</h4>' +
				'        <button type="button" class="close" data-dismiss="modal">&times;</button>\n' +
				'      </div>' +
				'      <div class="modal-body">' +
				'        <p class="text-success">Text byl zkopírován do schránky</p>' +
				'        <textarea readonly style="-webkit-box-sizing: border-box; -moz-box-sizing: border-box; box-sizing: border-box; width: 100%; min-height: 500px;"></textarea>' +
				'      </div>' +
				'      <div class="modal-footer">' +
				'        <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>' +
				'      </div>' +
				'    </div>' +
				'  </div>';
			document.body.appendChild(this.modalEl);

			this.modal = new Modal(this.modalEl);
		}

		this.modalEl.querySelector('textarea').innerHTML = html;

		this.modal.show();
	}

}